import React, { FC, useState, useRef } from 'react'
import { PageTitle } from '../../../../_designereyes/layout/core'
import { Toast } from 'primereact/toast'

// Import hooks
import { useOrderSelection } from './hooks/useOrderSelection'
import { useOrderData } from './hooks/useOrderData'
import { useOrderTabs } from './hooks/useOrderTabs'
import { useLineItems } from './hooks/useLineItems'

// Import components
import { DashboardMetrics } from './components/DashboardMetrics'
import { OrdersTable } from './components/Orderstable'
import './css/DeShippingTableWrapper.css'
import { useLineItemSelection } from './hooks/useLineItemSelection'


// Import types
export interface ShippingLineItem {
  workflow_id: number
  order_id: number
  line_item_id: number
  order_name: string
  fulfillment_status: string
  product_sku: string
  product_quantity: number
  product_price: number
  product_name: string
  variant_id: string
  fulfillment_location: string | null
  decline_reason: string | null
}

export interface ShippingOrder {
  order_id: string
  order_name: string
  fulfillment_locations: string
  created_at: string
  email: string
  phone: string
  financial_status: string
  total_items: number
  order_subtotal: number
  assigned_items: number
  unassigned_items: number
  pending_review_items: number
  declined_items: number
  shipped_items: number
}


export interface StoreInventory {
  storeCode: string;
  storeName: string;
  inventoryCount: number;
  hasEnoughInventory: boolean;
}


const DeShippingTablePage: FC = () => {
  const toast = useRef<Toast>(null)
  const orderData = useOrderData()
  const orderSelection = useOrderSelection(orderData.orders)
  const orderTabs = useOrderTabs()
  const lineItemsHook = useLineItems(orderSelection.selectedOrder?.order_id)
  const lineItemSelection = useLineItemSelection(lineItemsHook.lineItems, orderSelection.selectedOrder?.order_id)

  // Handle page change
  const handlePage = (e: any) => {
    orderData.setPage({ first: e.first ?? 0, rows: orderData.pagination.rows })
  }

  // Handle sort
  const handleSortChange = (e: any) => {
    orderData.setSort(e.sortField, e.sortOrder)
  }

  // Handle filter
  const handleFilter = (e: any) => {
    orderData.setFilters(e.filters)
  }

  return (
    <div className='p-4 card-body text-body bg-body'>
      <Toast ref={toast} />
      
      <div className="card shadow-sm p-4 mb-4">
        <div className="d-flex justify-content-between align-items-center">
          <h2 className='mb-0'>Shipping Orders</h2>
        </div>
  
        
        <DashboardMetrics 
          orderData={orderData}
          orderTabs={orderTabs}
        />
        
      </div>
  
      <OrdersTable
        orderSelection={orderSelection}
        orderData={orderData}
        orderTabs={orderTabs}
        lineItemsHook={lineItemsHook}
        lineItemSelection={lineItemSelection}
        onPage={handlePage}
        onSort={handleSortChange}
        onFilter={handleFilter}
      />
    </div>
  )
}

export const DeShippingTableWrapper: FC = () => {
  return (
    <>
      <PageTitle>Shipping Orders</PageTitle>
      <DeShippingTablePage />
    </>
  )
}